module.exports = __webpack_public_path__ + "static/media/banner-contact.de74a0a3.jpg";